import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { format } from "date-fns";
import { useState } from "react";
import Icon from "../../../icons";
import { cn } from "../../../utils";
import Button from "../../Button";
import Calendar from "../../Calendar";
import Popover, { PopoverContent, PopoverTrigger } from "../../Popover";
import { months } from "../constants";
import MonthYearSelect from "./MonthYearSelect";
const SingleDatePicker = ({ selected, onSelect, placeholder = "Selecionar data", size = "md", disabled, disabledTrigger, portal, className, classNameContent, defaultMonth, yearsRange, ...calendarProps }) => {
    const [date, setDate] = useState(selected);
    const [month, setMonth] = useState(defaultMonth || date || new Date());
    const [year, setYear] = useState(date?.getFullYear() || new Date().getFullYear());
    const handleSelect = (selectedDate) => {
        setDate(selectedDate);
        setYear(selectedDate.getFullYear());
        onSelect?.(selectedDate);
    };
    const handleMonthChange = (newMonth) => {
        const newMonthIndex = months.indexOf(newMonth);
        const newDate = new Date(year, newMonthIndex, date ? date.getDate() : new Date().getDate());
        setMonth(newDate);
        setDate(newDate);
        onSelect?.(newDate);
    };
    const handleYearChange = (newYear) => {
        const newYearNumber = Number(newYear);
        setYear(newYearNumber);
        if (date) {
            setMonth(new Date(newYearNumber, month.getMonth(), 1));
            setDate(new Date(newYearNumber, month.getMonth(), date.getDate()));
            onSelect?.(new Date(newYearNumber, month.getMonth(), date.getDate()));
        }
    };
    const buttonLabel = date ? format(date, "dd/MM/yyyy") : placeholder;
    return (_jsxs(Popover, { children: [_jsx(PopoverTrigger, { asChild: true, children: _jsx(Button, { "data-testid": "datepicker", variant: "outlined", color: "default", startIcon: _jsx(Icon, { name: "calendar-days" }), endIcon: _jsx(Icon, { name: "chevron-down" }), size: size, disabled: disabledTrigger, className: className, children: buttonLabel }) }), _jsxs(PopoverContent, { align: "start", showArrow: false, className: cn("space-y-2", classNameContent), portal: portal, children: [_jsx(MonthYearSelect, { selectedMonth: months[month.getMonth()], selectedYear: year.toString(), onMonthChange: handleMonthChange, yearsRange: yearsRange, onYearChange: handleYearChange }), _jsx(Calendar, { ...calendarProps, mode: "single", selected: date, onSelect: handleSelect, month: month, onMonthChange: setMonth, required: true, disabled: disabled })] })] }));
};
export default SingleDatePicker;
